/**
 * Deferred Google tag loading.
 *
 * Both Tag Manager (GTM-W8FTRVVJ, used for Google Ads conversions) and the
 * GA4 gtag stream used to load during the critical render path. They are now
 * loaded once the page is idle, or on the first real user interaction,
 * whichever happens first. Events pushed before the container arrives are kept
 * in dataLayer and replayed by Google automatically.
 */

export const GTM_ID = "GTM-W8FTRVVJ";

let loaded = false;

function loadGTM() {
  if (document.getElementById("gtm-script")) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  } as unknown as Record<string, unknown>);
  const s = document.createElement("script");
  s.id = "gtm-script";
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(s);
}

export function loadGoogleTags(initAnalytics: () => void) {
  if (loaded || typeof window === "undefined") return;
  loaded = true;
  loadGTM();
  initAnalytics();
}

export function scheduleGoogleTags(initAnalytics: () => void) {
  if (typeof window === "undefined" || loaded) return;

  const run = () => {
    cleanup();
    loadGoogleTags(initAnalytics);
  };

  const events: Array<keyof WindowEventMap> = [
    "pointerdown",
    "keydown",
    "touchstart",
    "scroll",
  ];
  const opts: AddEventListenerOptions = { once: true, passive: true };
  let timer: number | undefined;

  const cleanup = () => {
    events.forEach((e) => window.removeEventListener(e, run));
    if (timer) window.clearTimeout(timer);
  };

  events.forEach((e) => window.addEventListener(e, run, opts));

  const idle = (window as unknown as {
    requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => number;
  }).requestIdleCallback;

  if (idle) {
    idle(run, { timeout: 4000 });
  } else {
    timer = window.setTimeout(run, 2500);
  }
}
